module.exports = __webpack_public_path__ + "static/member_01-f1095497bff1ec9054021c3df83c6a18.jpg";